<div class="relative autocomplete-field">
  <input class="input" type="text" [placeholder]="placeholder" matInput [formControl]="formControl"
    [matAutocomplete]="auto">
  <mat-autocomplete #auto="matAutocomplete" panelClass="autocomplete-options-panel">
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        {{option}}
      </mat-option>
    }
  </mat-autocomplete>
  @if (canClear) {
    <span class="material-icons clear-icon" (click)="clear()">add</span>
  }
</div>